import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';
import React from 'react'

// Max-Width is set from 1260px width from component's design, and adding left/right padding of 24px each.
// calc() is used to explicitely declare how the width is calculated for readers, where 1308px would be hard to reference it's value from.
// !important is used, as all children of Layout component have 1440px max-width set by default, only certain elements have different Width.
export const CaseStudyCarouselContainer = styled.div`
  padding: 0em 2em;
  position: relative;
  max-width: calc(1260px + 48px) !important;
  margin: 1rem auto 8rem !important;

  @media all and (max-width: ${layout.xlg}){
    max-width: calc(960px + 48px) !important;
  }
  @media all and (max-width: ${layout.lg}){
    max-width: 100vw !important;
    padding: 0em 2.2em;
  }
  @media all and (max-width: ${layout.xs}){
    max-width: calc(96vw - 0px) !important;
    padding: 0em 0em;
  }
`

export const ChevronContainer = styled.div`
  align-self: center;
  justify-self: center;
  position: relative;
  cursor: pointer;
  transition: opacity ease-in-out 300ms;
`

export const CaseStudySliderContainer = styled.div`
  position: relative;
  overflow: hidden;
  display: grid;
`

export const LeftArrow = styled.svg.attrs({
  width: 15,
  height: 30,
  viewBox: '0 0 15 30',
  children: <path d="M11.785 27.607a1.333 1.333 0 01-2.236 1.453L.882 15.727a1.333 1.333 0 010-1.454L9.55.94a1.333 1.333 0 112.236 1.453L3.59 15l8.195 12.607z" fill="#2D263B" />
})`
  max-height: 24px;
  z-index: 6;
  top: 40%;
  left: -10px;

  @media all and (min-width: ${layout.xs}){
    left: -40px;
  }
`

export const RightArrow = styled.svg.attrs({
  width: 12,
  height: 30,
  viewBox: '0 0 12 30',
  children: <path d="M.882 27.607L9.076 15 .882 2.393A1.333 1.333 0 013.118.94l8.667 13.333a1.333 1.333 0 010 1.454L3.118 29.06a1.333 1.333 0 01-2.236-1.453z" fill="#2D263B" />
})`
  max-height: 24px;
  z-index: 6;
  top: 40%;
  right: -10px;

  @media all and (min-width: ${layout.xs}){
    right: -40px;
  }
`

export const CaseStudy = styled.div`
  background: ${palette.white};
  border: solid 1px ${palette.fog};
  overflow: hidden;
  margin: 0 32px;
  transition: all .3s ease-in-out;
  max-width: 100%;

  &:hover {
    box-shadow: 0 1px 10px #00000026,0 0 1px #0000000d;
  }

  @media all and (min-width: ${layout.xs}){
    margin: 0 24px;
  }

  @media all and (min-width: ${layout.subLg}){
    margin: 0 12px;
  }
`

export const CaseStudyTitle = styled.div`
  padding: 16px;
  align-self: center;
  text-decoration: none;
  color: ${palette.black};

  &:hover {
    color: ${palette.snowFlower};
  }

  @media all and (min-width: ${layout.lg}){
    padding: 24px;
  }
`

export const CaseStudyImage = styled.div`
  align-self: end;

  & > div {
    height: 180px;

    @media all and (min-width: ${layout.xs}){
      height: 220px;
    }

    @media all and (min-width: ${layout.subLg}){
      height: 280px;
    }
  }
`
